import React from "react";
import Box from "@material-ui/core/Box";
import Image from "gatsby-image";
import RemarkRenderer from "components/RemarkRenderer";

function StoryblokPhotoCard(props) {
  const { content } = props;
  const { image, imageAltText } = content;

  // console.log("PHOTO", props);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection={{ xs: "column", sm: "row" }}
      flex={1}
      pb={3}
      height="100%"
      // border="1px solid red"
    >
      <Box
        flex="1 1 15%"
        mr={{ xs: 0, sm: 3 }}
        mb={{ xs: 2, sm: 0 }}
        width={{ xs: "100%", sm: "auto" }}
        height="100%"
      >
        {!!image && !!image.localFile ? (
          <Image
            fluid={image.localFile?.childImageSharp.fluid}
            loading="eager"
            alt={imageAltText || "image"}
            // style={{ paddingBottom: "110.005%" }}
          />
        ) : null}
      </Box>
      <Box flex={2.5}>
        {content.photoCaption ? (
          <RemarkRenderer
            editable
            ast={content.photoCaption?.childMarkdownRemark?.htmlAst}
          />
        ) : null}
      </Box>
    </Box>
  );
}

export default StoryblokPhotoCard;
